import { useTranslation } from 'react-i18next'

import {
  LOCAL_STORAGE_BIRDVIEW_LAYOUT_KEY,
  LOCAL_STORAGE_BIRDVIEW_TILES_ORDER_KEY,
} from '../../../constants/storage'
import { BirdviewLayout } from '../BirdviewLayout'
import { BirdviewTileRow } from '../BirdviewTileRow'
import { BIRDVIEW_TILE_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'
import { getBirdviewStorageKey } from '../DashboardBirdview.utils.storage'
import { DashboardTile } from '../DashboardTile'

import { getBirdviewTileKey } from './BirdviewSkeletonLayout.utils'

function BirdviewSkeletonLayout({
  defaultLayout,
  storageScope,
  tiles,
  widgets,
  widgetTitles,
  onNavigate,
}) {
  const { t } = useTranslation()
  const { getListTarget } = useBirdviewListTarget()

  const layoutStorageKeyPrefix = getBirdviewStorageKey(
    LOCAL_STORAGE_BIRDVIEW_LAYOUT_KEY,
    [storageScope]
  )
  const tilesStorageKeyPrefix = getBirdviewStorageKey(
    LOCAL_STORAGE_BIRDVIEW_TILES_ORDER_KEY,
    [storageScope]
  )

  function getTileClickHandler(tile) {
    return function handleTileClick() {
      onNavigate(getListTarget(BIRDVIEW_TILE_TARGET[tile.key]))
    }
  }

  function renderTile(tile) {
    return (
      <DashboardTile
        dragHandle
        Icon={tile.Icon}
        count={tile.count}
        delta={tile.delta}
        deltaTone={tile.deltaTone}
        label={t(tile.labelKey)}
        state={tile.state}
        tone={tile.tone}
        onClick={getTileClickHandler(tile)}
      />
    )
  }

  // The stored order is read once on mount, so a new storage scope remounts
  // the row and the layout instead of keeping the previous role's state.
  return (
    <>
      {tiles ? (
        <BirdviewTileRow
          getItemId={getBirdviewTileKey}
          items={tiles}
          key={tilesStorageKeyPrefix}
          renderItem={renderTile}
          storageKeyPrefix={tilesStorageKeyPrefix}
        />
      ) : null}

      <BirdviewLayout
        defaultLayout={defaultLayout}
        key={layoutStorageKeyPrefix}
        overlayTitles={widgetTitles}
        storageKeyPrefix={layoutStorageKeyPrefix}
        widgets={widgets}
      />
    </>
  )
}

export default BirdviewSkeletonLayout
